// EN
export const derivedRatesSection = {
  title: "Tarifas derivadas",
  description:
    "Crie tarifas com base nos seus planos tarifários principais para conectar com diferentes OTAs, mantendo um preço base centralizado.",
  newRate: "Nova tarifa derivada",
  loading: "Carregando tarifas...",

  otaBadge: "OTA",
  otaLockedTitle: "Tarifa de OTA: gerenciada em 'Conectar OTA'",
  salePaused: "Vendas pausadas",

  columns: {
    name: "Nome",
    adjustment: "Ajuste",
    finalPrice: "Preço final",
  },

  actions: {
    resumeTitle: "Retomar vendas no Channex",
    pauseTitle: "Pausar vendas no Channex (stop_sell)",
    edit: "Editar",
    delete: "Excluir",
    protectedTitle: "Protegida: altere ou remova em 'Conectar OTA'",
  },

  empty: {
    title: "Nenhuma tarifa derivada",
    text: "Crie tarifas derivadas com base nos seus planos tarifários principais para conectar com OTAs",
    create: "Criar primeira tarifa derivada",
  },

  modal: {
    editTitle: "Editar tarifa derivada",
    createTitle: "Nova tarifa derivada",
    baseRatePlan: "Plano tarifário base",
    selectBasePlaceholder: "Selecione um plano tarifário base",
    selectBaseHint:
      "Selecione o plano tarifário a partir do qual esta tarifa derivada será calculada",
    nameLabel: "Nome da tarifa derivada",
    namePlaceholder: "ex.: tarifa Booking.com, tarifa Airbnb",
    nameHint: "Este nome ajudará você a identificar a tarifa ao conectar com as OTAs",
    adjustmentType: "Tipo de ajuste",
    percentage: "Percentual",
    fixedAmount: "Valor fixo",
    adjustmentValue: "Valor do ajuste",
    adjustmentValueHint: "(use valores negativos para descontos)",
    cancel: "Cancelar",
    saving: "Salvando...",
    update: "Atualizar",
    create: "Criar tarifa",
  },

  preview: {
    title: "Prévia",
    basePrice: "Preço base",
    increment: "Aumento",
    discount: "Desconto",
    finalPrice: "Preço final",
  },

  delete: {
    title: "Excluir tarifa derivada",
    warnStrong: "Esta ação não pode ser desfeita.",
    warnText:
      "Antes de excluir, verifique se a tarifa {name} não está vinculada a nenhuma OTA.",
    confirmLabel: "Digite o nome exato para confirmar:",
    confirmPlaceholder: "Digite o nome da tarifa exatamente",
    confirmHint:
      "Cole ou digite o nome exatamente como mostrado acima para habilitar o botão de excluir.",
    cancel: "Cancelar",
    processing: "Excluindo...",
    confirm: "Excluir permanentemente",
  },

  pause: {
    resumeTitle: "Retomar vendas",
    pauseTitle: "Pausar vendas",
    resumeText:
      "{code} será enviado ao Channex pelos próximos 500 dias. O canal voltará a receber disponibilidade e poderá aceitar reservas.",
    pauseText:
      "{code} será enviado ao Channex pelos próximos 500 dias. O canal vinculado a esta tarifa não poderá aceitar novas reservas enquanto estiver pausado.",
    note: "O calendário principal e os outros canais não serão afetados. Para retomar, clique no botão ▶ na tarifa.",
    cancel: "Cancelar",
    resuming: "Retomando...",
    pausing: "Pausando...",
    confirmResume: "Sim, retomar vendas",
    confirmPause: "Sim, pausar vendas",
  },

  toast: {
    loadError: "Erro ao carregar os dados",
    fillRequired: "Preencha todos os campos obrigatórios",
    updated: "Tarifa atualizada com sucesso",
    created: "Tarifa criada com sucesso",
    saveFailed: "Não foi possível salvar a tarifa",
    saveError: "Erro ao salvar a tarifa derivada",
    deleted: "Tarifa derivada excluída",
    deleteFailed: "Não foi possível excluir a tarifa",
    deleteLinkedOta: "Não é possível excluir: a tarifa está vinculada a uma OTA.",
    nameMismatch: "O nome informado não corresponde.",
    deleteError: "Erro ao excluir a tarifa derivada",
    salesPaused: "Vendas pausadas",
    salesResumed: "Vendas retomadas",
    toggleFailed: "Não foi possível alterar o status",
    toggleError: "Erro ao alterar o status da tarifa",
    // Guardada en local, pero Channex no aceptó el cambio (channex_synced:false).
    channexNotSynced: "A tarifa foi salva, mas o channel manager não aceitou a alteração: os canais continuam com a anterior. Revise os dados e tente novamente.",
  },

  // Estancia mínima propia de una derivada (own_min_stay). Campo y chip
  // compartidos: OwnMinStayField.vue / OwnMinStayChip.vue.
  ownMinStay: {
    label: "Estadia mínima própria (noites)",
    hint: "Vazio = a mesma da tarifa principal",
    mixedPlaceholder: "Vários",
    mixedHint: "Cada quarto tem um mínimo diferente. Se você digitar um, ele será aplicado a todos; se deixar vazio, cada um mantém o seu.",
    // Sugerencia por el nombre («Tarifa semanal» → 7): una pregunta de un clic.
    suggestQuestion: "Mínimo de {n} noite? | Mínimo de {n} noites?",
    suggestUse: "Usar",
    clear: "Remover",
    channelNote: "{channel} receberá um mínimo de {n} noite para esta tarifa. | {channel} receberá um mínimo de {n} noites para esta tarifa.",
    genericNote: "Os canais conectados (Booking etc.) receberão um mínimo de {n} noite para esta tarifa. | Os canais conectados (Booking etc.) receberão um mínimo de {n} noites para esta tarifa.",
    chip: "Mín. {n} noite | Mín. {n} noites",
    chipMixed: "Mín. diferente por quarto",
    chipTitle: "Estadia mínima própria desta tarifa: é enviada aos canais conectados",
    // Grupo con mínimos distintos: quitárselo a todas es un gesto aparte.
    clearAll: "Remover o mínimo de todas",
    clearedAllHint: "Ao salvar, todas perderão a mínima própria e usarão a da tarifa principal.",
    undo: "Desfazer",
  },
};
